import type { ColumnDef } from "@tanstack/react-table";
import { Image, MoreHorizontal, Trash2 } from "lucide-react";

import FileIcon from "@/assets/icons/file-icon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const getDocumentColumns = (
  handleDelete: (id: string) => Promise<void>,
  handleClick: (src: string) => void
): Array<
  ColumnDef<{
    id: string;
    title: string;
    isPdf: boolean;
    date: Date;
    src: string;
  }>
> => [
  {
    header: "Document",
    accessorKey: "title",
    cell: ({ row }) => (
      <div
        className="flex gap-3 cursor-pointer"
        onClick={() => handleClick(row.original.src)}
      >
        {row.original.isPdf ? <FileIcon /> : <Image />}
        <div className="flex text-sm items-center font-medium">
          {row.original.title}
        </div>
      </div>
    ),
    meta: {
      filterVariant: "text",
    },
  },
  {
    accessorFn: (row) => row.date.toLocaleDateString(),
    header: "Date",
    id: "date",
    cell: ({ row }) => (
      <div className="text-sm font-medium text-gray-600">
        {row.original.date.toLocaleDateString()}
      </div>
    ),
  },
  {
    id: "actions",
    accessorFn: () => "",
    header: "",
    cell: ({ row }) => {
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild className="flex justify-end">
            <button className="ml-auto p-1 hover:bg-gray-100 rounded">
              <MoreHorizontal className="w-5 h-5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              className="text-error-700 focus:bg-red-100 cursor-pointer"
              onClick={async () => {
                await handleDelete(row.original.id);
              }}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Supprimer
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
    enableSorting: false,
    enableColumnFilter: false,
  },
];
